import React from "react";
import Container from "../../../../components/Container";
import TablaSolicitudes from "../../../solicitudes/components/TablaSolicitudes/TablaSolicitudes";

const Dispositivos = () => {
  return (
    <Container label={"Mis dispositivos"}>
      <TablaSolicitudes />
    </Container>
  );
};

export default Dispositivos;
